module.exports = __webpack_public_path__ + "static/media/mobile-blog-img1.35708f71.png";